export const vi = {
  // ===== MENU =====
  menu: {
    home: "Trang chủ",
    about: "Giới thiệu",
    products: "Sản phẩm - Giải pháp",
    investment: "Đầu Tư & Dịch Vụ",
    customers: "Khách hàng - Đối tác",
    projects: "Dự án tiêu biểu",
    contact: "Liên hệ",
    recruitment: "Tuyển Dụng",
    news: "Tin Tức",
  },

  // ===== SHAREHOLDER DOCUMENTS =====
  shareholder_documents: {
    title: "Cổ đông",
    page_name: "Tài liệu cổ đông",
    desc: "Các báo cáo và tài liệu công bố chính thức của tập đoàn được cập nhật minh bạch, hỗ trợ cổ đông và nhà đầu tư tra cứu thông tin nhanh chóng.",
    search_placeholder: "Tìm kiếm báo cáo, tài liệu...",
    clear_search: "Xoá tìm kiếm",
    filter_by_year: "Lọc theo năm",
    all_years: "Tất cả các năm",
    year: "Năm",
    published_docs: "tài liệu công bố",
    reset_filter: "Đặt lại bộ lọc",
    loading: "Đang tải tài liệu cổ đông...",
    not_found: "Không tìm thấy tài liệu nào",
    try_search_again: "Thử thay đổi từ khoá hoặc năm lọc để tìm kiếm lại.",
    soon_published: "Tài liệu chuyên mục này sẽ sớm được công bố.",
    view_doc: "Xem tài liệu",
    updating_file: "Đang cập nhật tệp",
    hsv_corporate: "HSV CORPORATE",
    fallback_title: "Tài liệu dành cho cổ đông",
  },

  // ===== STRATEGIC OBJECTIVES DIAGRAM =====
  strategic_objectives: {
    title: "MỤC TIÊU CHIẾN LƯỢC",
    left: {
      section1_title: "CHIẾN LƯỢC PHÁT TRIỂN HỆ SINH THÁI - ESM",
      section1_item1:
        "Web thương mại điện tử, App, bán Sỉ, Lẻ, phân phối hàng đầu Việt Nam trong lĩnh vực cung cấp thuốc, dược phẩm và các dụng cụ chăm sóc sức khỏe y tế - Dược trong mô hình Hệ Sinh Thái - ESM",
      section2_title: "CHIẾN LƯỢC PHÁT TRIỂN",
      section2_item1:
        "Phát triển bền vững dựa trên nền tảng xây dựng chuỗi giá trị, mang lại tiện ích lớn nhất cho Doanh nghiệp, Nhà Sản Xuất, Nhà Phân phối, Hệ thống Chuỗi Bán Sỉ, Lẻ và BV, PK, PM. Trạm y tế....",
      section2_item2:
        "Nâng cao sức khoẻ cho cộng đồng, cải thiện thể trạng người Việt Nam.",
    },
    right: {
      section1_title: "CHIẾN LƯỢC HỆ THỐNG PHÂN PHỐI",
      section1_item1:
        "Tích hợp Distribution Management System (DMS) để gia tăng Chuỗi kết nối giữa Nhà sản xuất, Nhà phân phối và Hệ thống Bán nhằm tạo mối liên kết chặt chẽ phục vụ cho công tác Quản trị.",
      section1_item2:
        "Ứng dụng hệ thống E-logistics vào hệ thống cung ứng hàng hóa.",
      section2_title: "CHIẾN LƯỢC DỊCH VỤ",
      section2_item1:
        "Tích hợp Giải pháp Call Center (3CX), Zalo, Email Hotline trong Chiến lược Chăm sóc Khách hàng chuyên nghiệp.",
    },
    center: {
      top: "MỤC",
      bottom: "TIÊU",
    },
  },

  // ===== BUSINESS MODEL DIAGRAM =====
  business_model: {
    title: "MÔ HÌNH & KINH DOANH",
    partners: {
      title: "Đối tác chính",
      items: [
        "Đối tác chính: Là nhà đầu tư Chính cho Dự Án",
        "HSV là đối tác Tư vấn, triển khai cung cấp giải pháp công nghệ, hạ tầng",
      ],
    },
    activities: {
      title: "Hoạt động chính",
      items: [
        "Các hành động",
        "Phát triển Platform DMS, eCommerce",
        "Xây dựng Hệ thống ERP.",
        "Vận hành, Hệ sinh thái y tế, dịch vụ trên DMS và sàn TTTM Điện Tử",
      ],
    },
    resources: {
      title: "Tài nguyên chính",
      items: [
        "Nguồn lực tài chính từ đối tác quỹ đầu tư, tổ chức tín dụng + HSV để xây dựng.",
        "Nguồn lực công nghệ để phát triển và vận hành.",
      ],
    },
    value: {
      title_top: "Sản Phẩm Dịch Vụ (II)",
      title: "Đề xuất giá trị",
      items: [
        "Giá trị chất lượng",
        "Mô hình PaaS duy nhất ở VN, cho phép quy tụ các Chuỗi Bệnh viện, PK, PM, TYT, Nhà Phân phối , TTTM, Hệ thống Chuỗi Nhà Thuốc ......",
        "Các Hệ Thống DMS, Sàn TMĐT, TTTM và Hệ thống Chợ Sỉ và Lẻ tận dụng các tiện ích trong Hệ Thống",
      ],
    },
    relationships: {
      title: "Mối quan hệ khách hàng",
      items: [
        "Phân loại khách hàng theo nhóm",
        "Khách hàng qua kênh truyền thông online. ( 3CX ), Zalo, Email, Hotline",
      ],
    },
    channels: {
      title: "Kênh truyền thông",
      items: [
        "Kinh doanh dịch vụ ngành Y tế/ Dược qua kênh online với các Khách hàng cá nhân và Hệ thống khác",
        "Kinh doanh PaaS qua hệ thống",
      ],
    },
    segments: {
      title: "Phân khúc khách hàng",
      items: [
        "Phân khúc Khách hàng của sàn PaaS là khách Sỉ, Lẻ, Chuỗi Bệnh Viện, Phòng Khám, Phòng Mạch, Trạm y tế. Hệ thống cửa hàng,v.v.",
        "Các cơ quan nhà nước quản lý ngành",
      ],
    },
    badges: {
      infrastructure: "Hạ Tầng Kinh Doanh (III)",
      customer: "Khách Hàng (I)",
    },
  },

  // ===== ARCHITECTURE DIAGRAM =====
  architecture_diagram: {
    sidebar_left: "CÁC TỔ CHỨC BÊN NGOÀI",
    sidebar_right: "HỆ THỐNG BẢO MẬT VÀ ATTT\nTHÔNG TƯ, QUY ĐỊNH BỘ BAN NGÀNH",
    external_orgs: {
      hospital: "BỆNH VIỆN/\nPHÒNG KHÁM\nVÀ ĐƠN VỊ\nLIÊN KẾT",
      einvoice: "HÓA ĐƠN\nĐIỆN TỬ",
      esign: "CHỮ KÍ SỐ",
      payment: "CỔNG THANH\nTOÁN",
      bhxh: "BẢO HIỂM XÃ HỘI VIỆT NAM",
      vnpd: "VNEID",
      boyte: "BỘ Y TẾ",
    },
    top_bar: {
      doctor: "CÁN BỘ Y BÁC SĨ",
      admin: "BAN GIÁM ĐỐC VÀ VẬN HÀNH",
      patient: "BỆNH NHÂN",
    },
    app_layer: {
      doctor_apps: "PM ứng dụng cho CBNV Bệnh viện\n(app, web, mobile app...)",
      patient_apps:
        "PM ứng dụng cho bệnh nhân\n(web, mobile app, kios, hotline...)",
    },
    middle_layer: {
      exam: {
        title: "ỨNG DỤNG KHÁM CHỮA BỆNH",
        items: ["EMR", "HIS", "LIS", "RIS-PACS"],
      },
      management: {
        title: "ỨNG DỤNG QUẢN TRỊ ĐIỀU HÀNH",
        items: [
          "Tài chính Kế Toán",
          "Quản trị Bệnh viện",
          "Hành chính Nhân Sự",
          "Văn bản điện tử",
          "Quản lý chất lượng",
          "Phân tích và Báo cáo",
          "Quản lý trang thiết bị",
          "Các ứng dụng khác",
        ],
      },
      patient_services: {
        title: "ỨNG DỤNG CHO BỆNH NHÂN",
        items: [
          "Tra cứu bệnh án",
          "Website, Mobile App",
          "Đặt lịch khám",
          "KIOS, QMS thông minh",
          "Mạng xã hội",
          "Các hệ thống khác",
        ],
      },
    },
    data_exchange: {
      boyte: {
        title: "BỘ Y TẾ",
        items: [
          "CSDL Dược",
          "CSDL BHYT",
          "CSDL Thông tin Bệnh nhân",
          "CSDL khác",
        ],
        lgsp: "TRỤC LGSP - BỘ Y TẾ",
      },
      other_units: {
        title: "CÁC ĐƠN VỊ KHÁC",
        items: [
          "CSDL BHXH",
          "CSDL Quốc gia và Dân cư",
          "CSDL Chữ kí số",
          "CSDL Hóa đơn điện tử",
          "CSDL Thanh toán điện tử",
          "CSDL khác",
        ],
      },
      internal: {
        title: "NỘI BỘ BỆNH VIỆN",
        items: [
          "Nền tảng AI/ML",
          "Nền tảng BigData",
          "Nền tảng trực quan hóa",
          "Các chuẩn trao đổi dữ liệu",
          "Xác thực, phân quyền",
          "Các dịch vụ khác",
        ],
      },
    },
    integration_bus: {
      title: "TRỤC TÍCH HỢP VÀ QUẢN LÝ CHIA SẺ DỮ LIỆU",
      items: [
        "Quản lý danh mục dùng chung",
        "Quản lý phân quyền người dùng",
        "Quản lý dịch vụ",
        "Định danh bệnh nhân",
        "Trích xuất và chia sẻ thông tin y tế",
      ],
    },
    database_layer: {
      internal_db: {
        title: "CSDL NỘI BỘ BỆNH VIỆN",
        exam: {
          title: "CSDL KHÁM CHỮA BỆNH",
          items: ["CSDL EMR", "CSDL HIS", "CSDL LIS", "CSDL RIS-PACS"],
        },
        management: {
          title: "CSDL QUẢN TRỊ ĐIỀU HÀNH",
          items: ["CSDL TCKT", "CSDL Chất lượng BV", "CSDL Nghiên cứu KH", "CSDL Chỉ đạo tuyến", "CSDL Quản lý tài sản", "CSDL Văn bản điện tử"],
        },
      },
      data_warehouse: {
        title: "KHO DỮ LIỆU BỆNH VIỆN",
        analysis: {
          title: "DỮ LIỆU PHÂN TÍCH",
          items: [
            "Quản lý meta data",
            "Mô hình hóa dữ liệu",
            "Phân tích dữ liệu dựa trên AI/ML",
            "Phân tích dữ liệu",
          ],
        },
        storage: {
          title: "DỮ LIỆU LƯU TRỮ",
          items: ["Dữ liệu có và bán cấu trúc", "Dữ liệu phi cấu trúc"],
          cylinder: "KHO DỮ LIỆU",
        },
      },
      external_db: {
        title: "CSDL PHỤC VỤ BÊN NGOÀI",
        query: {
          title: "CSDL TRA CỨU",
          items: [
            "CSDL Đặt lịch khám",
            "CSDL Tra cứu kết quả",
            "CSDL cổng thông tin tra cứu",
            "CSDL khác",
          ],
        },
      },
    },
  },

  // ===== ABOUT SUBMENU =====
  about_menu: {
    overview: "Tổng quan",
    message: "Thông điệp",
    logo_values: "Logo và Giá trị nền tảng",
    vision_mission: "Tầm nhìn - Sứ mệnh - Giá trị cốt lõi",
    development: "Định hướng phát triển",
    culture: "Văn hóa và Môi trường làm việc",
    policies: "Chính sách nhân sự",
    leadership: "Ban lãnh đạo",
  },

  // ===== PRODUCTS SUBMENU =====
  products_menu: {
    company_products: "Sản phẩm công ty",
    healthcare_solutions: "Giải pháp y tế",
    system_integration: "Tích hợp hệ thống",
    it_services: "Dịch vụ và hạ tầng CNTT",
    enterprise_40: "Giải pháp quản lí doanh nghiệp 4.0",
    cloud_services: "Dịch vụ đám mây",
    iot_solutions: "Giải pháp IoT",
  },

  // ===== CUSTOMERS SUBMENU =====
  customers_menu: {
    typical_customers: "Khách hàng tiêu biểu",
    strategic_partners: "Đối tác chiến lược",
    hospital: "Bệnh viện",
    clinic: "Phòng khám & nha khoa",
    insurance: "Bảo hiểm",
    service: "Các ngành dịch vụ",
    bank: "Ngân hàng",
    medical_supply: "Chuỗi cung ứng thiết bị y tế",
  },

  // ===== CONSULTING SERVICES =====
  consulting_services: {
    investment: "Tư vấn đầu tư",
    service_consultation: "Tư vấn dịch vụ",
    investment_procedure:
      "Tư vấn thủ tục đầu tư, vận hành bệnh viện, phòng khám",
  },

  // ===== OTHER COMMON TEXTS =====
  common: {
    email: "Email",
    call_now: "Gọi ngay",
    dark: "Tối",
    light: "Sáng",
    back_to_top: "Lên đầu trang",
    home: "Trang chủ",
    vietnamese: "Tiếng Việt",
    search_placeholder: "Nhập từ khóa tìm kiếm...",
  },

  // ===== SEARCH =====
  search: {
    results_for: "Kết quả tìm kiếm cho:",
    customers: "Khách hàng / Đối tác",
    projects: "Dự án",
    products: "Sản phẩm & Giải pháp",
    ecosystem: "Hệ sinh thái",
    news: "Tin tức",
    no_results_title: "Chưa có kết quả",
    no_results_desc1: "Không tìm thấy nội dung nào khớp với từ khóa",
    no_results_desc2: "Vui lòng thử tìm kiếm với từ khóa khác.",
    empty_title: "Vui lòng nhập từ khóa",
    empty_desc: "Nhập từ khóa vào ô tìm kiếm để bắt đầu.",
    searching: "Đang tìm kiếm...",
    error: "Đã xảy ra lỗi khi tìm kiếm.",
  },

  // ===== LEADERSHIP =====
  leadership: {
    mr: "Ông",
    ms: "Bà",
    chairman: " Chủ tịch HĐQT",
    vice_chairman: "Phó chủ tịch HĐQT",
    general_director: "Tổng Giám Đốc",
    board_member: "Thành Viên HĐQT",
    deputy_general_director_business: "Phó TGĐ Kinh Doanh",
    deputy_general_director: "Phó Tổng giám đốc",
    head_of_department: "Trưởng khoa",
    phd: "Tiến Sĩ",
  },

  // ===== HOME =====
  home: {
    banner_subtitle: "Giải pháp công nghệ - Chăm sóc sức khỏe",
    banner_title: "Healthcare Solution VIETNAM",
    introduction_title: "Giới Thiệu",
    introduction_subtitle: "HEALTHCARE SOLUTION VIETNAM",
    years_established: "20 Năm",
    years_desc: "Hình thành & phát triển.",
    revenue_target: "2500 Tỷ",
    revenue_desc: "Kế hoạch mục tiêu 2026 - 2030",
    top_12_solutions: "Top 12",
    top_12_desc: "Đơn vị cung cấp dịch vụ tích hợp hệ thống hàng đầu Việt Nam.",
    awards: "3 Năm",
    awards_desc: "Giải thưởng cúp vàng do Hiệp hội CN TP HCM.",
    products_text: "Chúng tôi có",
    products_title: "Sản Phẩm Và Giải Pháp",
    services_text: "Dịch Vụ",
    services_title: "Sản Phẩm Của Công Ty",
    esm_text: "ESM",
    esm_title: "Hệ Sinh Thái ESM",
    esm_section_title: "ECOSYSTEM SMART MEDIC",
    esm_description:
      "Esm là hệ sinh thái thông minh cho ngành y tế có vốn đầu tư nước ngoài tự tin hoạt động trong lĩnh vực Chăm sóc sức khỏe & Dược phẩm, giải pháp công nghệ.",
    esm_mission_title: "NHIỆM VỤ CỦA ESM",
    esm_mission:
      "Sứ mệnh của chúng tôi là nâng cao sức khỏe và hạnh phúc bằng cách cung cấp dịch vụ chăm sóc sức khỏe tổng thể tốt nhất.",
    view_details: "Xem Chi Tiết",
    typical_projects_text: "Nổi Bật",
    typical_projects_title: "Dự Án Tiêu Biểu",
    in_progress_text: "Dự Án",
    in_progress_title: "Đang Được Triển Khai",
    section4_text: "Kết nối",
    section4_title: "Đối Tác Chiến Lược",
    news_title: "Tin Tức",
    news_text: "Có thể bạn chưa biết?",
  },

  // ===== TYPICAL PROJECTS =====
  typical_projects: {
    overview: "Tổng quát",
    hsv_role: "Vai trò HSV",
  },

  // ===== CONTACT =====
  // contact: {
  //   title_center: "HEALTHCARE SOLUTION VIET NAM",
  //   page_name: "Trang Chủ",
  //   text: "Liên Hệ",
  //   title: "Liên Hệ",
  //   hcm_office: "Trụ sở Hồ Chí Minh",
  //   hcm_address: "64 Đường số 2, KDC Him Lam, Phường Tân Hưng, Quận 7, TP. Hồ Chí Minh",
  //   hcm_phone1: "(84-28) 38371002",
  //   hcm_phone2: "(84)907.632.112",
  //   email: "info@hsv.com.vn",
  //   maps_title: "Google Maps - Hồ Chí Minh",
  //   representative_office: "Văn Phòng Đại Diện",
  //   rep_address: "232/7 Võ Văn Kiệt, Phường Cầu Ông Lãnh, Quận 1, TP. Hồ Chí Minh",
  //   rep_phone1: "(84-28) 39300614",
  //   rep_phone2: "(84) 917.632.112",
  // },

  // // ===== FOOTER =====
  footer: {
    //   home: "Trang chủ",
    //   hcm_office: "Trụ sở Hồ Chí Minh",
    //   hcm_address: "64 Đường số 2, KDC Him Lam, Phường Tân Hưng, Quận 7, TP. Hồ Chí Minh",
    //   hcm_hotline: "Hotline: (84)907.632.112",
    //   hcm_fax: "Fax: (84-28) 38371002",
    //   rep_office: "Văn phòng đại diện",
    //   rep_address: "232/7 Võ Văn Kiệt, Phường Cầu Ông Lãnh, Quận 1, TP. Hồ Chí Minh",
    //   rep_hotline: "Hotline: (84) 917.632.112",
    //   rep_fax: "Fax: (84-28) 39300614",
    copyright: "Copyright © 2016  Healthcare Solution Viet Nam.",
    connect: "Kết nối",
  },

  // ===== NOT FOUND =====
  notfound: {
    title: "404",
    message: "It looks like you're lost...<br/>That's a trouble?",
    button: "Quay lại trang chủ",
  },

  // ===== TOP BANNER - PAGES =====
  pages: {
    about: "Giới thiệu",
    products_solutions: "Sản phẩm - Giải pháp",
    investment_services: "Đầu Tư & Dịch Vụ",
    customers_partners: "Khách hàng - Đối tác",
    typical_projects: "Dự án tiêu biểu",
    recruitment: "Tuyển Dụng",
    news: "Tin Tức",
    contact: "Liên hệ",
    leadership: "Ban lãnh đạo",
  },

  // ===== NEWS =====
  news: {
    news: "Tin Tức",
    //   activities: "Tin Hoạt Động",
    //   events: "Tin Sự Kiện",
  },

  // ===== RECRUITMENT =====
  recruitment: {
    title: "Tuyển Dụng",
    position: "Vị Trí Tuyển Dụng",
    dateup: "Ngày Tuyển",
    dateout: "Hạn Nộp Hồ Sơ",
    detail: "Chi Tiết",
    view_detail: "Xem Chi Tiết",
    search_placeholder: "Tìm kiếm vị trí tuyển dụng...",
    department_all: "Tất cả phòng ban",
    job_type_all: "Tất cả hình thức",
    clear_filter: "Xóa bộ lọc",
    no_jobs: "Không tìm thấy vị trí tuyển dụng phù hợp với bộ lọc.",
    total_jobs: "vị trí đang tuyển",

    // CV Submission Form
    badge_opportunity: "CƠ HỘI NGHỀ NGHIỆP",
    apply_now: "Ứng tuyển ngay vị trí này",
    apply_subtitle:
      "Gửi thông tin và CV của bạn trực tiếp cho bộ phận Tuyển dụng HSV Corp",
    fullname_label: "Họ và tên",
    fullname_placeholder: "Nhập đầy đủ họ và tên...",
    phone_label: "Số điện thoại",
    phone_placeholder: "Nhập số điện thoại liên hệ...",
    email_label: "Email liên hệ",
    email_placeholder: "Nhập địa chỉ email...",
    upload_cv_label: "Tải lên CV cá nhân (PDF, DOC, DOCX)",
    upload_cv_button: "Nhấn để chọn tệp CV hoặc đính kèm từ máy tính...",
    rule_hint_formats:
      "Cho phép tệp doc, docx, xls, xlsx, ppt, pptx, pdf và lên đến 3mb",
    rule_hint_chars:
      "Tên tập tin không chứa các kí tự đặc biệt như ' /, [, *, <, >, ;",
    cover_letter_label: "Thư giới thiệu / Ghi chú",
    tab_type_text: "✍️ Nhập văn bản",
    tab_type_file: "📄 Tải file đính kèm",
    cover_letter_placeholder:
      "Nhập tóm tắt kinh nghiệm, điểm mạnh hoặc lời nhắn gửi đến nhà tuyển dụng...",
    upload_cover_button: "Chọn file Thư giới thiệu (PDF, DOCX)...",
    submit_btn: "Gửi Hồ Sơ Ứng Tuyển",
    submitting_btn: "Đang nộp hồ sơ...",
    success_title: "Nộp hồ sơ ứng tuyển thành công!",
    success_message:
      "Cảm ơn bạn đã quan tâm. Bộ phận HR của HSV Corp sẽ xem xét và liên hệ với bạn trong thời gian sớm nhất.",
    err_invalid_file:
      "Tệp không hợp lệ! Cho phép tệp doc, docx, xls, xlsx, ppt, pptx, pdf.",
    err_file_size: "Dung lượng tập tin vượt quá giới hạn tối đa 3MB.",
    err_file_chars:
      "Tên tập tin không được chứa các ký tự đặc biệt như ' /, [, *, <, >, ;",
    err_select_cv: "Vui lòng chọn tệp CV của bạn.",
    err_submit_fail: "Có lỗi xảy ra khi gửi CV. Vui lòng thử lại.",
  },

  // ===== HSV CORP & HSV THƯƠNG MẠI OVERVIEW =====
  hsv_corp_overview: {
    sec1_badge: "PHẦN 1: GIỚI THIỆU TỔNG QUAN HSV CORP",
    sec1_title:
      "Tập Đoàn HSV Corp - Nền Tảng Hạ Tầng Y Tế & Quản Trị Doanh Nghiệp",
    sec1_desc:
      "HSV Corp tập trung xây dựng, vận hành và chuyển đổi số mạng lưới y tế toàn diện bao gồm chuỗi bệnh viện, phòng khám, đào tạo y khoa, dịch vụ CSKH chuẩn hóa và định hướng phát triển bền vững.",
    sec2_badge: "PHẦN 2: CHIẾN LƯỢC KINH DOANH",
    sec2_title: "Định Hướng Chiến Lược Kinh Doanh & Tăng Trưởng",
    sec2_desc:
      "Chiến lược kinh doanh toàn diện kết hợp mở rộng mạng lưới y tế, tối ưu vận hành, tư vấn M&A và quản trị tài chính bền vững.",
    strat_1_title: "Chiến Lược M&A & Mở Rộng Quy Mô",
    strat_1_desc:
      "Chủ động M&A, hợp tác và sáp nhập các cơ sở y tế tiềm năng nhằm nhân rộng mạng lưới phục vụ bệnh nhân trên toàn quốc.",
    strat_2_title: "Chuyển Đổi Số & Ứng Dụng Y Tế Thông Minh",
    strat_2_desc:
      "Đẩy mạnh số hóa toàn diện từ bệnh án điện tử EMR, tư vấn từ xa Telehealth đến ứng dụng AI hỗ trợ chẩn đoán hình ảnh.",
    strat_3_title: "Tối Ưu Hóa Tài Chính & Tăng Trưởng Bền Vững",
    strat_3_desc:
      "Xây dựng chuỗi doanh thu đa dạng kết hợp giữa khám chữa bệnh, cung ứng vật tư y tế, đào tạo và tư vấn tài chính y tế.",
    nav_sec1: "Phần 1: HSV Corp",
    nav_sec2: "Phần 2: Chiến Lược Kinh Doanh",
    badge: "HỆ SINH THÁI HSV CORP",
    title: "Nền Tảng Hạ Tầng Y Tế, Đào Tạo Y Khoa & Tư Vấn M&A - Tài Chính",
    subtitle:
      "HSV_Corp tập trung xây dựng, vận hành và chuyển đổi số mạng lưới y tế toàn diện bao gồm chuỗi bệnh viện, phòng khám, đào tạo y khoa, dịch vụ CSKH và tư vấn M&A - tái cơ cấu tài chính doanh nghiệp.",
    pillars_badge: "CÁC TRỤ CỘT THÀNH VIÊN",
    pillars_title: "Các Đơn Vị Thành Viên HSV Corp",
    projects_badge: "DỰ ÁN TIÊU BIỂU",
    projects_title: "Dự Án Y Tế & M&A Tiêu Biểu HSV Corp",
    explore_btn: "Khám Phá Chi Tiết",
    // 1. Chuỗi bệnh viện
    hospital_title: "Chuỗi Bệnh Viện",
    hospital_tag: "Hạ Tầng Y Tế Cốt Lõi",
    hospital_desc:
      "Tư vấn đầu tư, thiết kế, xây dựng và vận hành chuỗi bệnh viện đa khoa & chuyên khoa đạt tiêu chuẩn quốc tế.",
    hospital_hl1: "Tích hợp HIS & EMR bệnh án điện tử",
    hospital_hl2: "Phòng mổ thông minh & PACS",
    hospital_hl3: "Quy trình vận hành chuẩn JCI",
    hospital_stat: "05+",
    hospital_stat_label: "Bệnh viện liên kết",
    // 2. Chuỗi phòng khám
    clinic_title: "Chuỗi Phòng Khám",
    clinic_tag: "Chăm Sóc Ban Đầu & Chuyên Khoa",
    clinic_desc:
      "Mạng lưới phòng khám đa khoa, nha khoa hiện đại chuẩn hóa quy trình tiếp đón, chẩn đoán và chăm sóc khách hàng.",
    clinic_hl1: "Hệ thống đặt lịch & tiếp đón thông minh",
    clinic_hl2: "Kết nối xét nghiệm & nhà thuốc",
    clinic_hl3: "Hồ sơ sức khỏe điện tử cá nhân",
    clinic_stat: "20+",
    clinic_stat_label: "Phòng khám chuẩn hóa",
    // 3. Đào tạo
    education_title: "Đào Tạo & Chuyển Giao",
    education_tag: "Phát Triển Nhân Lực",
    education_desc:
      "Chương trình đào tạo nhân sự y tế, chuyển giao quy trình vận hành y khoa và phần mềm quản trị cơ sở y tế.",
    education_hl1: "Đào tạo quản trị y tế chuyên sâu",
    education_hl2: "Chuyển giao công nghệ phần mềm",
    education_hl3: "Khóa học theo nhu cầu doanh nghiệp",
    education_stat: "1000+",
    education_stat_label: "Nhân sự đã đào tạo",
    // 4. CSKH
    care_title: "Dịch Vụ CSKH & Vận Hành",
    care_tag: "Dịch Vụ Chăm Sóc Đa Kênh",
    care_desc:
      "Trung tâm tiếp nhận đa kênh, quản lý trải nghiệm bệnh nhân 24/7 và dịch vụ y tế tận nơi theo yêu cầu.",
    care_hl1: "Tổng đài chăm sóc 24/7",
    care_hl2: "Hệ thống quản lý phản hồi",
    care_hl3: "Kết nối dịch vụ y tế tại nhà",
    care_stat: "24/7",
    care_stat_label: "Hỗ trợ liên tục",
    // 5. M&A & Tư vấn tài chính
    ma_title: "Tư Vấn M&A & Tài Chính Doanh Nghiệp",
    ma_tag: "Tái Cơ Cấu & Huy Động Vốn",
    ma_desc:
      "Tư vấn Mua bán & Sáp nhập (M&A), huy động vốn đầu tư, tư vấn tái cơ cấu nợ và cấu trúc lại mô hình quản trị doanh nghiệp y tế.",
    ma_hl1: "Mua bán & Sáp nhập (M&A) cơ sở y tế",
    ma_hl2: "Huy động vốn đầu tư chiến lược",
    ma_hl3: "Tư vấn tái cơ cấu nợ & tối ưu vốn",
    ma_hl4: "Tái cơ cấu quản trị doanh nghiệp",
    ma_stat: "M&A",
    ma_stat_label: "Tư vấn chiến lược",

    // Dedicated M&A Section
    ma_section_badge: "DỊCH VỤ TƯ VẤN M&A & TÀI CHÍNH DOANH NGHIỆP",
    ma_section_title: "Dịch Vụ Tư Vấn M&A & Tái Cơ Cấu Tài Chính chuyên sâu",
    ma_section_desc:
      "HSV_Corp cung cấp chuỗi giải pháp tư vấn M&A, huy động vốn đầu tư và tái cấu trúc tài chính chuyên nghiệp dành riêng cho các dự án y tế và doanh nghiệp.",

    ma_service_1_title: "Mua Bán & Sáp Nhập (M&A)",
    ma_service_1_desc:
      "Tư vấn toàn diện quy trình M&A các dự án y tế, bệnh viện, phòng khám & doanh nghiệp công nghệ: định giá, thẩm định (Due Diligence) & đàm phán hợp đồng.",
    ma_service_1_f1: "Tư vấn định giá & thẩm định chi tiết",
    ma_service_1_f2: "Xây dựng cấu trúc giao dịch tối ưu",

    ma_service_2_title: "Huy Động Vốn Đầu Tư",
    ma_service_2_desc:
      "Xây dựng phương án gọi vốn đầu tư, kết nối mạng lưới các quỹ đầu tư tài chính, nhà đầu tư chiến lược trong & ngoài nước.",
    ma_service_2_f1: "Hồ sơ gọi vốn & Pitch Deck chuẩn quốc tế",
    ma_service_2_f2: "Kết nối quỹ đầu tư & nhà đầu tư chiến lược",

    ma_service_3_title: "Tư Vấn & Tái Cơ Cấu Nợ",
    ma_service_3_desc:
      "Đánh giá toàn diện sức khỏe tài chính, tái cấu trúc các khoản nợ, tối ưu chi phí vốn & đảm bảo dòng tiền vận hành an toàn.",
    ma_service_3_f1: "Tái cấu trúc kỳ hạn & chi phí nợ vay",
    ma_service_3_f2: "Tối ưu hóa dòng tiền & an toàn tài chính",

    ma_service_4_title: "Tái Cơ Cấu Doanh Nghiệp",
    ma_service_4_desc:
      "Tái cấu trúc mô hình quản trị, chuẩn hóa quy trình vận hành y khoa & phần mềm, nâng cao hiệu quả hoạt động & tối ưu giá trị doanh nghiệp.",
    ma_service_4_f1: "Chuẩn hóa sơ đồ tổ chức & SOPs",
    ma_service_4_f2: "Số hóa & nâng cao hiệu suất quản trị",
  },
  hsv_commerce_overview: {
    badge: "HỆ SINH THÁI HSV THƯƠNG MẠI",
    title: "Nền Tảng Phần Mềm, Thương Mại & Truyền Thông Y Tế",
    subtitle:
      "HSV Thương Mại tập trung phát triển các giải pháp phần mềm chuyên sâu, phân phối hạ tầng thiết bị y tế - công nghệ và vận hành các kênh truyền thông thương hiệu toàn diện.",
    pillars_badge: "3 TRỤ CỘT HỆ SINH THÁI",
    pillars_title: "Các Đơn Vị Thành Viên HSV Thương Mại",
    projects_badge: "DỰ ÁN TIÊU BIỂU",
    projects_title: "Dự Án Công Nghệ & Thương Mại Tiêu Biểu",
    explore_btn: "Xem Chi Tiết",
    // 1. Phần mềm
    software_title: "Phần Mềm & Chuyển Đổi Số",
    software_tag: "Giải Pháp Phần Mềm Y Tế",
    software_desc:
      "Phát triển phần mềm quản lý bệnh viện (HIS), bệnh án điện tử (EMR), quản lý phòng khám và giải pháp chuyển đổi số MedTech.",
    // 2. Thương mại
    commerce_title: "Thương Mại & Chuỗi Cung Ứng",
    commerce_tag: "Thương Mại & Thiết Bị Y Tế",
    commerce_desc:
      "Cung ứng thiết bị y tế, vật tư chuyên ngành, hạ tầng máy chủ CNTT và giải pháp điện toán đám mây cho doanh nghiệp.",
    // 3. Truyền thông
    media_title: "Truyền Thông & Quảng Cáo",
    media_tag: "Truyền Thông Thương Hiệu",
    media_desc:
      "Truyền thông thương hiệu y tế, sản xuất nội dung số, chiến dịch quảng bá đa kênh và tổ chức sự kiện truyền thông.",
  },

  // ===== ESM FLOWCHART =====
  esm_flowchart: {
    title: "TƯƠNG QUAN GIỮA ESM - KHỐI Y TẾ DƯỢC VÀ TÀI CHÍNH",
    khach_hang_title: "KHÁCH HÀNG LỰA CHỌN DỊCH VỤ TRÊN HST - ESM",
    khoi_y_te: "KHỐI Y TẾ - DƯỢC",
    tai_chinh: "Tài Chính",
    cskh: "CSKH - Dịch Vụ",
    nhan_su: "Nhân Sự",
    van_hanh: "Vận Hành",
    bao_cao: "Báo Cáo<br/>- Thống<br/>Kê",
    dich_vu: "Dịch vụ",
    goi_kham: "Gói Khám",
    cham_soc: "Chăm sóc",
    duoc_pham: "Dược Phẩm",
    mua_bh: "Mua Bảo<br/>hiểm",
    tuyen_dung: "Tuyển dụng<br/>Bác sỹ",
    thanh_toan: "CỔNG<br/>THANH<br/>TOÁN ĐIỆN<br/>TỬ",
    ngan_hang: "NGÂN<br/>HÀNG",
    the_ngan_hang: "Thẻ<br/>ngân<br/>hàng<br/>liên kết",
    zalo_sms: "ZALO,<br/>SMS",
  },

  // ===== PAYMENT UTILITIES =====
  payment_utilities: {
    title: "Tiện ích trong việc thanh toán",
    one_card: "THẺ ONE CARD",
    medika_card: "Thẻ Thành Viên",
    medika_link: "Thẻ liên kết với Bệnh viện\n– Phòng khám – Nhà\nthuốc",
    bank_card: "Thẻ liên kết với Ngân\nhàng",
    user: "Người dùng",
    wallet: "Ví điện tử",
    points: "Tích lũy\nĐiểm",
    balance_management: "Quản lý số dư tài\nkhoản",
    id_management: "Quản lý bởi 1 hệ Thống ID\nKhách hàng",
    point_accumulation: "Tích lũy\nđiểm sau\nmỗi lần\ngiao dịch",
  },

  // ===== ESM IMPLEMENTATION =====
  esm_implementation: {
    title: "Đóng góp hệ sinh thái",
    item_blockchain: "Phát triển\nnền tảng\nBlockchain",
    item_creativity: "Gia tăng sáng\ntạo sản phẩm\nngành Y tế",
    item_connection: "Gia tăng kết\nnối chuỗi liên\nkết",
    item_payment: "Tiện ích\ntrong việc\nthanh\ntoán",
    item_expansion: "Phát triển,\nmở rộng dịch\nvụ phát sinh",
    patient: "Bệnh nhân",
    smart_ecosystem: "Hệ sinh thái thông minh",
    beneficiary: "Đối tượng thụ hưởng",
    
    // Innovation diagram
    info_medical: "Thông tin về Y khoa",
    health_management: "Quản lý Sức Khỏe",
    preventive_care: "Y tế Dự Phòng",
    insurance: "Dịch vụ Bảo hiểm",
    emr: "Hồ sơ thông tin\nBệnh án điện tử",
    telehealth: "Tư vấn trực tuyến\nbệnh qua điện thoại",
    home_doctor: "Bác sĩ tại Gia",
    online_booking: "Đặt lịch khám Online",
    info_product: "Thông tin về\nSản phẩm Y Tế",

    // Connection & Expansion diagrams
    innovation_title: "Gia tăng sáng tạo sản phẩm ngành Y tế",
    connection_title: "Gia tăng kết nối chuỗi liên kết",
    conn_hospital: "Bệnh viện",
    conn_clinic: "Phòng khám",
    conn_supply_chain: "Chuỗi cung ứng về Y Tế",
    conn_bank: "Ngân hàng",
    conn_other_suppliers: "Nhà cung cấp khác",
    conn_non_medical: "Sản phẩm dịch vụ phi Y Tế",
    expansion_title: "Phát triển, mở rộng dịch vụ phát sinh - Smart Healthcare",
    exp_smartphone: "Cảnh báo tình trạng sức khỏe bằng Smart Phone",
    exp_bmi: "Quản lý chỉ số BMI & AI",
    exp_smartwatch: "Vòng đeo tay thông minh & AI",
    exp_247: "Dịch vụ chăm sóc sức khỏe 24/7",
    exp_delivery: "Giao thuốc tại nhà",
    exp_records: "Lưu giữ hồ sơ thông tin bệnh án",
    exp_ambulance: "Đưa đón KCB tận nơi"
  },

  // ===== BLOCKCHAIN DIAGRAM =====
  esm_blockchain_diagram: {
    title: "Phát triển nền tảng Blockchain lưu trữ Hồ sơ bệnh án, hợp đồng",
    transaction: "Giao dịch",
    patient: "Bệnh nhân",
    exam: "Khám bệnh",
    payment_meds: "Thanh toán\nNhận thuốc",
    data_decentralized: "Dữ liệu\nPhân cấp",
    smart_records: "Hồ sơ\nBệnh án\nThông minh",
    home_token: "Home Token",
    master_node: "Master Node",
    pow_pos: "PoW / PoS",
    consensus: "Consensus"
  },

  // ===== SLIDE DATA =====
  slide_data: {
    marketOpportunity: {
      title: "Cơ Hội Gia Nhập Thị Trường & Mô Hình Hợp Tác Công Tư (PPP)",
      subtitle:
        "Chuyển đổi từ mô hình quản trị công sang mô hình hợp tác PPP theo mục tiêu, nâng cao chất lượng dịch vụ y tế.",
      publicHospital: {
        title: "Bệnh Viện Công (Quản Trị Theo Định Lượng)",
        badge: "Thực Trạng & Hạn Chế",
        items: [
          "Thu nhập phụ thuộc vào khung lương của Bộ Y Tế",
          "Năng lực không được thưởng xứng đáng; chưa có cơ chế thưởng phạt hiệu quả",
          "Tập trung chủ yếu vào cấp cứu; chưa tối ưu trải nghiệm bệnh nhân",
          "Hạ tầng IT chưa được xem trọng; xử lý công việc phạm vi cục bộ",
          "Thiếu tính tự chủ, bị ràng buộc bởi các rào cản chính sách",
          "Thiếu người quản lý bệnh viện chuyên nghiệp, quản lý hệ thống yếu kém (Tài chính, IT, CRM)",
        ],
      },
      partnerHospital: {
        title: "Bệnh Viện Hợp Tác PPP (Quản Trị Theo Mục Tiêu)",
        badge: "Giải Pháp & Cơ Hội HSV",
        items: [
          "Cơ chế khuyến khích nhân viên y tế rõ ràng, người bệnh làm trọng tâm",
          "Thu nhập theo năng suất, hiệu quả công việc và chất lượng điều trị",
          "Đầu tư mạnh cho hạ tầng IT thông minh tăng hiệu quả quản lý và điều trị",
          "Quy trình vận hành mang tính hệ thống, tăng cường phối hợp liên khoa",
          "Chấp nhận gia nhập và linh động theo chính sách Y tế với tính tự chủ cao",
        ],
      },
    },
    coreBusinessStrategy: {
      title: "CHIẾN LƯỢC KINH DOANH LÕI",
      description:
        "HEALTHCARE SOLUTION VIETNAM tập trung vào các hoạt động chữa trị (medical), khám-chẩn đoán (non-medical), đồng thời sẽ phát triển hỗn hợp các mảng kinh doanh bổ trợ và thành lập các công ty cung cấp chuyên biệt về Dược & TBYT và các dịch vụ thương mại khác.",
      channels: {
        title: "KÊNH PHÂN PHỐI ĐỒNG BỘ",
        items: [
          "E-hospital / Kênh PP điện tử",
          "Walk in",
          "Clinic",
          "Hợp tác Bác sĩ tư",
        ],
      },
      hospitalSystem: {
        title: "HỆ THỐNG BỆNH VIỆN",
        core: {
          title: "CORE BUSINESS",
          entrance: "Welcome",
          diagnostics: ["Tư vấn", "Cận lâm sàn", "Chẩn đoán", "Xét nghiệm"],
          center: "MEDICA",
        },
        postMedical: {
          title: "Post-medical Accomodation",
          items: ["Patient", "Family"],
        },
      },
      subsidiaries: {
        items: [
          "Công ty dược phẩm",
          "Cty DVTM",
          "Trung tâm y khoa kỹ thuật cao",
          "Các phòng khám Bác sĩ trong BV",
        ],
      },
      publicHospitals: {
        title: "BỆNH VIỆN ĐA KHOA CÔNG LẬP",
      },
    },
    revenueOptimizationDetail: {
      title: "CHIẾN LƯỢC TỐI ĐA HÓA DOANH THU",
      subtitle:
        "Chính sách khách hàng đặt trọng tâm vào bệnh nhân và người gây ảnh hưởng là bác sĩ tại các kênh phân phối với mức giá đảm bảo tính cạnh tranh, dễ chấp nhận. Do đó, việc tối đa hóa doanh thu sẽ tập trung vào các vấn đề ....",
      pillars: [
        {
          id: "patient-attraction",
          title: "Thu hút bệnh nhân",
          items: [
            "Kênh phân phối đồng bộ.",
            "Hợp tác với bác sĩ giỏi.",
            "Hợp tác chăm sóc sức khỏe toàn diện với các DN trên địa bàn.",
            "Môi trường BV khách sạn, Hospitality chuyên nghiệp.",
            "Quy trình chuẩn đoán bệnh nhanh, hiệu quả.",
            "Danh tiếng chuyên môn và công dân doanh nghiệp tốt.",
            "Lắng nghe các nhu cầu khó lên tiếng của người bệnh (mute-demand).",
            "Quan tâm đến các vấn đề cá nhân & niềm tin tôn giáo.",
          ],
          subTitle: "Lấy người bệnh làm trọng tâm.",
          subItems: [
            "Dịch vụ chăm sóc khách hàng tận nơi (home care).",
            "Cơ sở dữ liệu khách hàng (bệnh nhân & người nhà) để quản lý CRM đủ mạnh.",
            "Liên kết với các bệnh viện để nhận hỗ trợ, chuyển giao kỹ thuật.",
            "Phòng khám các bác sĩ trong BV theo quy trình chữ U (tăng số dịch vụ sử dụng/người).",
            "Hợp tác với bác sĩ giỏi để thu hút bệnh nhân.",
            "Chế độ thù lao, đãi ngộ hấp dẫn dựa trên năng lực và hiệu quả đóng góp.",
          ],
        },
        {
          id: "product-price",
          title: "Dịch vụ / Sản phẩm",
          items: [
            "Danh mục dịch vụ phong phú, nhiều lựa chọn.",
            "Cập nhật nhanh tiến bộ Y khoa.",
            "Dịch vụ exclusive theo nhu cầu đặc biệt.",
            "Quyền cung cấp dịch vụ commercial trong khuôn viên chung.",
          ],
          subTitle: "Giá cả",
          subItems: [
            "Mức giá lưu trú phù hợp đảm bảo mục tiêu lấp đầy công suất giường bệnh nhanh nhất.",
            "Các gói giá linh hoạt theo mức độ chấp nhận của BN.",
          ],
        },
      ],
      diagram: {
        center: "BỆNH NHÂN",
        middle: "BÁC SĨ",
        outer: "BỆNH VIỆN",
        arrows: ["Acquire", "Cross-sell", "Up-sell", "Retain", "Advocacy"],
      },
    },
    marketBarriers: {
      title: "Rào Cản Thị Trường",
      subtitle:
        "Những khó khăn làm nản lòng các nhà đầu tư bệnh viện riêng rẽ.",
      items: [
        {
          title: "Vốn Đầu Tư",
          desc: "Vốn đầu tư lớn, khả năng thu hồi vốn chậm, khó tiếp cận vốn vay thương mại.",
        },
        {
          title: "Thủ Tục Đất Đai",
          desc: "Khó tìm vị trí đẹp thuận lợi. Chi phí đền bù giải tỏa cao. Thủ tục phức tạp, mất thời gian.",
        },
        {
          title: "Nguồn Nhân Lực",
          desc: "Khó tuyển dụng bác sĩ chuyên môn cao, danh tiếng. Quản lý đội ngũ bác sĩ, điều dưỡng phức tạp.",
        },
        {
          title: "Nguồn Bệnh Nhân",
          desc: "Tâm lý bệnh nhân đi theo bác sĩ và ưa thích bệnh viện công danh tiếng. Không đủ cơ sở bệnh nhân ban đầu.",
        },
        {
          title: "Kiểm Soát Y Khoa",
          desc: "Khó kiểm soát biến chứng y khoa. Dễ bị tai tiếng bởi dư luận và cơ quan quản lý chuyên môn.",
        },
      ],
    },
    pppStructure: {
      title: "Giải Pháp Hợp Tác Xã Hội Hóa (Mô Hình PPP)",
      subtitle: "Thỏa thuận cổ đông thành lập Công Ty Cổ Phần Bệnh Viện (SPV)",
      phases: [
        {
          id: "inputs",
          title: "Nguồn Lực Đóng Góp",
          hsv: {
            name: "HSV INVESTOR",
            items: [
              { label: "Vai trò", text: "Là nhà đầu tư tài chính" },
              { label: "Vốn góp", text: "Từ 50-70% bằng Tiền Mặt" },
              {
                label: "Tư vấn vận hành",
                text: "Thuê công ty, bệnh viện nước ngoài tư vấn vận hành quản lý",
              },
              {
                label: "Trách nhiệm chính",
                text: "Xây dựng bệnh viện cung cấp tài chính. Quản trị công ty & hệ thống",
              },
            ],
          },
          public: {
            name: "BỆNH VIỆN CÔNG",
            items: [
              {
                label: "Vai trò",
                text: "Đóng góp lợi thế thương hiệu & chuyên môn",
              },
              {
                label: "Vốn góp",
                text: "30-40% bằng lợi thế đất đai & thương hiệu BV",
              },
              {
                label: "Nhân sự chủ chốt",
                text: "Phó chủ tịch; GĐBV (GM). Trưởng khoa & nhân sự cơ hữu. Chủ tịch HĐ Y khoa",
              },
              {
                label: "Trách nhiệm chính",
                text: "Quỹ đất sạch & thủ tục. Cung cấp nhân lực. Quản lý chuyên môn (Phẫu thuật, Cấp cứu & Chữa trị)",
              },
            ],
          },
          shared: {
            title: "HẠNG MỤC DÙNG CHUNG & DỊCH VỤ PHỤ TRỢ",
            items: [
              {
                label: "Giấy phép chung",
                text: "Sử dụng chung giấy phép hoạt động bệnh viện",
              },
              {
                label: "Cơ sở hạ tầng",
                text: "Chia sẻ CSHT & thiết bị. Khuôn viên, cây xanh dùng chung (chia sẻ chi phí theo diện tích)",
              },
              {
                label: "Dịch vụ phụ trợ",
                text: "Cung cấp các dịch vụ thương mại & phụ trợ trong khuôn viên chung",
              },
            ],
          },
        },
        {
          id: "core",
          title: "BỆNH VIỆN XÃ HỘI HÓA (SPV)",
          subtitle:
            "Pháp nhân Công Ty Cổ Phần BV (Sự kết hợp & Hợp tác toàn diện)",
          coreFunction:
            "DV CHẤT LƯỢNG CAO KHÁM BỆNH, PHẪU THUẬT, LƯU TRÚ BỆNH NHÂN",
          features: [
            "Hợp nhất nguồn vốn mạnh mẽ và hệ thống quản trị chuẩn quốc tế từ HSV.",
            "Tích hợp lợi thế chuyên môn, uy tín và nguồn bệnh nhân dồi dào từ Bệnh Viện Công.",
            "Sử dụng chung giấy phép, hoạt động đồng bộ và hiệu quả.",
            "HẠ TẦNG KHUÔN VIÊN, CÂY XANH DÙNG CHUNG CHIA SẺ CHI PHÍ THEO DIỆN TÍCH.",
          ],
        },
      ],
    },
    holdingStructure: {
      title: "Chiến Lược Hoạch Định & Cấu Trúc Holding",
      subtitle:
        "Xây dựng mô hình Holding nhằm sở hữu, quản lý hợp nhất các công ty thành viên, đảm bảo tính liên tục của chiến lược và sự thích ứng với thay đổi của thị trường.",
      tabs: [
        "Mô Hình Lựa Chọn",
        "Kiến Trúc Mở",
        "Chức Năng Quản Lý",
        "Hình Thức Cấu Trúc",
        "Quản Trị Tài Chính",
      ],
      models: {
        title: "Mô Hình Quản Lý Holding",
        desc: "Trên cơ sở chiến lược hoạch định, chúng tôi có kế hoạch thành lập công ty holding nhằm sở hữu, quản lý hợp nhất các công ty thành viên với mô hình lựa chọn giữa Kiến trúc chiến lược và Kiểm soát chiến lược.",
        axis: { left: "Tự trị, độc lập cao", right: "Kiểm soát chặt chẽ" },
        items: [
          {
            type: "Cổ đông năng động",
            enType: "Active shareholder",
            features:
              "Quản lý dựa trên kết quả kinh doanh công ty con có đạt được không?",
            finance:
              "Phân bổ dòng tiền tự do vào các đơn vị mới. Huy động và phân bổ vốn, nhưng có sự tách bạch các đơn vị",
            color: "red",
          },
          {
            type: "Kiến trúc chiến lược",
            enType: "Strategic Architect",
            features:
              "Quản lý theo chiều ngang và dọc. Cty con tự tìm cơ hội KD, Cty mẹ thẩm định cơ hội",
            finance:
              "Cung cấp các hướng dẫn chiến lược. Huy động và phân bổ nguồn vốn, hậu thuẫn tài chính một số trường hợp vận hành",
            color: "navy",
          },
          {
            type: "Kiểm soát chiến lược",
            enType: "Strategic Control",
            features:
              "Cty mẹ sẽ tìm kiếm cơ hội KD và kiểm soát chặt hơn ở cty con",
            finance:
              "Quản lý chiến lược ở cấp độ Holding, chủ động điều hành theo chiến lược ở cấp độ cty con. Chia sẻ bảng cân đối",
            color: "yellow",
          },
          {
            type: "Nhà vận hành",
            enType: "Operator",
            features: "Cty mẹ trực tiếp điều hành mọi hoạt động của Cty con",
            finance:
              "Quyết định tất cả các vấn đề chiến lược, quản trị, điều hành. Bảng cân đối hợp nhất",
            color: "blue",
          },
        ],
        proposal: {
          title: "Đề xuất lựa chọn",
          points: [
            "Thống nhất chiến lược ở cấp độ tập đoàn Holding, nhưng đảm bảo năng lực hiệu chỉnh cao cho điều hành.",
            "Liên kết chặt chẽ các Bệnh viện & Công ty kinh doanh.",
            "Bảng cân đối Holding hợp nhất các công ty con.",
          ],
        },
      },
      architecture: {
        title: "Kiến Trúc Mở (Open Architecture)",
        desc: "Cấu trúc Holding cần tiến hóa đáp ứng tính liên tục của chiến lược. Giải pháp là xây dựng kiến trúc mở và Module hóa các chức năng có khả năng tùy biến.",
        layers: [
          { 
            name: "Hội đồng Quản trị - BOD", 
            role: "Chủ tịch", 
            color: "blue",
            descriptions: [
              "Chức năng Trung tâm: Lãnh đạo và kiểm soát chiến lược",
              "Thực hành thông lệ quản trị tốt Các Hội đồng chuyên môn"
            ]
          },
          { 
            name: "Ban Điều Hành - BOE", 
            role: "CEO", 
            color: "orange",
            descriptions: [
              "Điều hành chiến lược hàng ngày",
              "Các khối vận hành chuyên môn theo từng nhánh: Bệnh viện, chuyên khoa, phòng khám",
              "Các khối/phòng quản lý, giám sát, hỗ trợ, xử lý tập trung"
            ]
          },
          {
            name: "Các Khối Chức Năng",
            roles: ["Các khối chuyên môn", "Khối/Phòng Hỗ trợ"],
            color: "gray",
          },
          {
            name: "Các công ty trực thuộc (Hospitals & BU)",
            roles: [
              "BV ĐK",
              "BV chuyên khoa",
              "Phòng khám",
              "Nhà thuốc",
              "Trường ĐTYK",
            ],
            color: "yellow",
            descriptions: [
              "Các Công ty BV trực thuộc",
              "Cty Dược (mô hình Tổng công ty), 1 Cty Thương mại - Dịch vụ cung cấp các dịch vụ trong bệnh viện (giặt ủi, ăn uống, siêu thị, vệ sinh, giữ xe,...)",
              "1 trường đào tạo điều dưỡng y tế (Liên kết hợp tác)"
            ]
          },
        ],
      },
      orgChart: {
        title: "Sơ Đồ Chức Năng & Quản Lý Chuyên Môn",
        desc: "Cấu trúc Holding theo các khối quản lý chuyên môn, cung cấp các chỉ đạo và format chuẩn cho các bệnh viện và đơn vị kinh doanh từ khâu xúc tiến đến vận hành.",
        ceo: "CEO",
        topStaff: [
          "Hợp tác quốc tế & truyền thông",
          "Ban chiến lược",
          "Quỹ trách nhiệm xã hội",
        ],
        directors: ["GĐ Đầu tư", "GĐ Kinh doanh", "GĐ Chuyên môn"],
        medicalCenter: "Trung tâm y khoa kỹ thuật cao",
        departments: [
          {
            name: "Tài chính",
            tasks: [
              "Huy động vốn",
              "Phân bổ vốn",
              "Đo lường h.động",
              "Báo cáo quản trị",
              "Các vấn đề thuế",
            ],
          },
          {
            name: "Kế toán",
            tasks: ["Kiểm soát chứng từ", "Báo cáo tài chính"],
          },
          {
            name: "Pháp lý",
            tasks: [
              "Quy chế hoạt động",
              "Soạn thảo HĐ",
              "Soát xét tuân thủ",
              "NC phân tích luật",
            ],
          },
          {
            name: "Quản trị công ty",
            tasks: [
              "Chỉ dẫn Q.Trị",
              "Lương thưởng & bổ nhiệm TV BoD",
              "Đánh giá CG tại các công ty con",
            ],
          },
          {
            name: "Quản trị nhân lực",
            tasks: ["Tuyển dụng", "Lương thưởng", "Đãi ngộ cán bộ"],
          },
          {
            name: "Kiểm toán nội bộ & quản lý rủi ro",
            tasks: ["Kiểm toán rủi ro", "Đánh giá độc lập"],
          },
        ],
        units: [
          "Bệnh viện điều dưỡng",
          "Phòng khám",
          "Bệnh viện chuyên khoa",
          "Cty dược phẩm",
          "Cty DVTM",
          "Đào tạo",
        ],
      },
      structuralForm: {
        title: "HÌNH THỨC CẤU TRÚC CÔNG TY CỔ PHẦN HSV",
        desc: "Cấu trúc các chức năng của Holding đảm bảo mối liên hệ rõ ràng giữa công ty mẹ với các công ty con từ khâu xúc tiến thành lập, đầu tư đến khi chuyển giao quyền điều hành...",
        topLevel: ["Hội đồng quản trị", "CEO & President", "Chiến lược", "CSR"],
        departments: [
          {
            name: "Tài Chính",
            tasks: [
              "Huy động và phân bổ vốn",
              "QL Tài chính – TM hợp nhất",
              "Đo lường hoạt động",
            ],
          },
          {
            name: "Quản lý",
            tasks: [
              "Chỉ dẫn CG chung",
              "Bổ nhiệm chức danh",
              "Đánh giá TV HĐQT...",
            ],
          },
          {
            name: "Pháp lý",
            tasks: ["Hướng dẫn pháp lý", "Quản lý tuân thủ"],
          },
          {
            name: "Nhân sự",
            tasks: ["Tuyển dụng, QLNS", "Quản lý hệ thống"],
          },
          {
            name: "Quản trị rủi ro",
            tasks: ["Quản lý rủi ro", "Kiểm toán nội bộ"],
          },
        ],
        leftMatrix: [
          { category: "Đối tác", items: ["HĐQT & QL đối tác"] },
          {
            category: "Kế hoạch",
            items: [
              "Chính sách, chỉ đạo",
              "Quy trình chuyên môn",
              "Cận lâm sàn, lâm sàn",
            ],
          },
          {
            category: "Thương mại",
            items: [
              "Chính sách KD",
              "Bán hàng cấp độ chuyên gia",
              "Quản lý kênh phân phối",
            ],
          },
          {
            category: "Đầu tư",
            items: ["Xúc tiến, đầu tư, xây dựng", "Chuyển giao"],
          },
        ],
        hospitals: [
          { name: "Phòng khám", size: "small" },
          { name: "Bệnh viện Chuyên khoa", size: "medium" },
          { name: "Bệnh viện Đa khoa", size: "large" },
        ],
      },
      finance: {
        title: "Chính Sách Quản Trị Tài Chính Tập Đoàn",
        desc: "Tập trung huy động vốn, quản lý cấu trúc vốn mục tiêu, kế hoạch chi tiêu định lượng và phân phối lợi nhuận đáp ứng hài hòa lợi ích các bên.",
        categories: [
          {
            name: "HUY ĐỘNG VỐN",
            sub: [
              {
                type: "Vốn Điều lệ",
                target:
                  "Đảm bảo vốn tham gia của HSV và công ty liên quan. Chào bán phát hành riêng lẻ cho các nhà đầu tư. Có kế hoạch niêm yết trên TTCK trong/ngoài nước tại thời điểm thích hợp.",
                choice:
                  "Hướng đến các nhà Đầu tư: Cùng chia sẻ tầm nhìn & thực thi triển vọng. Có tiềm lực tài chính mạnh & hỗ trợ chiến lược, nhân sự... Đầu tư giá trị dài hạn, không xung đột lợi ích.",
              },
              {
                type: "Vốn vay",
                target:
                  "Đàm phán các điều kiện vay vốn ưu đãi từ ngân hàng nội địa. Từng SPV & công ty độc lập tự chịu trách nhiệm với sự hỗ trợ đàm phán của CHH. Kiểm soát dư nợ mục tiêu.",
                choice:
                  "Ngân hàng: Ưu tiên BIDV, Vietinbank, VCB. Hợp đồng nguyên tắc tài trợ cả gói. Thời gian vay tối thiểu 10 năm, 3 năm ân hạn, lãi suất ưu đãi. Quỹ đầu tư VIG hỗ trợ.",
              },
            ],
          },
          {
            name: "PHÂN BỔ VỐN",
            sub: [
              {
                type: "Đầu tư & Mua sắm",
                target:
                  "Holding phê duyệt, giám sát thực hiện ngân sách hàng năm. Kế hoạch đầu tư, mua sắm, chi tiêu có định lượng.",
                choice:
                  "Quản lý tập trung dòng tiền mặt (cash management) tại ngân hàng đầu mối. Quyết định các hạn mức suất đầu tư, mua sắm tại các đơn vị. Giám sát hạn mức phê duyệt.",
              },
            ],
          },
          {
            name: "PHÂN PHỐI KQKD",
            sub: [
              {
                type: "Phân phối lợi nhuận",
                target:
                  "Đáp ứng hài hòa lợi ích các bên liên quan. Trích lập các quỹ nghiệp vụ đầy đủ & dự phòng vốn. Trích lập quỹ từ thiện & đầu tư trách nhiệm.",
                choice:
                  "Gia tăng EVA cho vốn cổ đông. Kế hoạch tái đầu tư cổ tức.",
              },
            ],
          },
        ],
      },
    },
    hospitalNetwork: [
      {
        name: "BVĐK Quảng Ngãi",
        beds: "500",
        location: "Quảng Ngãi",
        type: "Bệnh viện Đa khoa",
      },
      {
        name: "BVĐK Vũng Tàu",
        beds: "400",
        location: "Bà Rịa - Vũng Tàu",
        type: "Bệnh viện Đa khoa",
      },
      {
        name: "BVĐK Bến Tre",
        beds: "450",
        location: "Bến Tre",
        type: "Bệnh viện Đa khoa",
      },
      {
        name: "BVNK Đắk Lắk",
        beds: "200",
        location: "Đắk Lắk",
        type: "Bệnh viện Chuyên khoa",
      },
      {
        name: "BVĐK Bình Thuận",
        beds: "200",
        location: "Bình Thuận",
        type: "Bệnh viện Đa khoa",
      },
      {
        name: "BVTH Cần Thơ",
        beds: "200",
        location: "Cần Thơ",
        type: "Bệnh viện Chấn thương",
      },
      {
        name: "BVĐK TP.HCM",
        beds: "150",
        location: "TP. Hồ Chí Minh",
        type: "Bệnh viện Đa khoa",
      },
    ],

    strategicVision: {
      title: "Tầm Nhìn Chiến Lược Cho Chuỗi Bệnh Viện",
      subtitle:
        "Định hướng phát triển bền vững, tối ưu vận hành và nâng cao năng lực cạnh tranh cho hệ thống y tế HSV Corp.",
      pillars: [
        {
          label: "Cân bằng Chất lượng & Lợi nhuận",
          points: [
            "Áp dụng các quy trình vận hành và quản lý bệnh viện tiên tiến để tăng cường hiệu quả.",
            "Xây dựng KPI để đo hiệu suất hoạt động tại bệnh viện, khoa hoặc nhân viên y tế.",
          ],
        },
        {
          label: "Lựa chọn Chuyên môn Chiến thuật",
          points: [
            "Bệnh viện đa khoa với nhiều chuyên khoa, giúp đa dạng hóa nguồn thu nhập, tối đa công suất, tạo nguồn thu ổn định.",
            "Thu hút nhân tài dựa trên môi trường làm việc tốt và mức độ sắp xếp bác sĩ nhằm đáp ứng mục tiêu cổ đông.",
            "Lượng khách hàng cơ bản lớn và khả năng khai thác thông tin khách hàng sẽ tăng khả năng phát triển khách hàng.",
          ],
        },
        {
          label: "Cấu trúc Vốn & Mua bán Sáp nhập",
          points: [
            "Cơ cấu vốn thích hợp bao gồm đối tác chiến lược và nhà đầu tư chính vay vốn dài hạn để tìm tài trợ cho các dự án.",
            "Tăng trưởng qua việc sáp nhập và mua lại (M&A).",
          ],
        },
        {
          label: "Mô hình Chuỗi Hub-and-Spoke",
          points: [
            "Một chuỗi y tế với mô hình hub-and-spoke (Kết hợp bệnh viện và phòng khám) là cần thiết để xây dựng quy mô và phát triển một thương hiệu mạnh.",
            "Quản lý chuyên môn của các bác sĩ và các nhóm dịch vụ là mục tiêu quan trọng để đáp ứng nhu cầu và đạt tăng trưởng cao.",
          ],
        },
      ],
    },
    revenueOptimizationMatrix: {
      title: "Giải Pháp Tối Đa Hóa Doanh Thu",
      subtitle:
        "Tăng trưởng doanh thu toàn diện dựa trên các nhân tố cốt lõi và chiến lược linh hoạt.",
      factors: [
        {
          id: "category",
          name: "Danh mục",
          shared: ["Đa dạng hóa dịch vụ", "Phát triển sản phẩm mới"],
          medical: [
            "Quy định danh mục chi tiết các dịch vụ khám, chữa bệnh cơ bản & phục vụ hỗ trợ.",
            "Cập nhật nhanh chóng tiến bộ y khoa.",
            "Thực hiện từng bước nhóm dịch vụ cash-cow.",
          ],
          nonMedical: [
            "Các gói dịch vụ phòng trọn gói, chăm sóc đặc biệt theo nhu cầu.",
            "Dịch vụ Hospitality chuyên nghiệp, các sản phẩm chăm sóc gia tăng giá trị.",
          ],
        },
        {
          id: "pricing",
          name: "Giá dịch vụ",
          shared: [
            "Chính sách định giá & biểu phí linh hoạt.",
            "Các chương trình khám bệnh trọn gói.",
            "Chẻ nhỏ giá dịch vụ đơn lẻ.",
          ],
          medical: [],
          nonMedical: [],
          pricingEvolution: [
            { label: "Theo giá vốn + biên độ mục tiêu", short: "Cost" },
            { label: "Theo giá cạnh tranh", short: "Cạnh tranh" },
            {
              label: "Theo cảm nhận & sự hài lòng của KH",
              short: "Khách hàng",
            },
            { label: "Giá mục tiêu", short: "Giá mục tiêu" },
          ],
        },
        {
          id: "customers_visits",
          name: "Số KH & Số lượt",
          shared: [
            "Tâm lý «bệnh nhân tìm bác sĩ».",
            "Tăng cường kênh phân phối bán hàng.",
            "Quy trình xử lý ngắn, hiệu quả.",
          ],
          medical: [
            "Mời gọi bác sĩ giỏi mở phòng khám trong bệnh viện.",
            "Kênh phân phối đồng bộ & dịch vụ khách hàng chuyên nghiệp.",
            "Hợp tác với các bác sĩ tư đưa bệnh nhân đến chữa trị.",
            "Trình độ tư vấn, khám, chữa bệnh của bác sĩ.",
          ],
          nonMedical: [
            "Điều chỉnh giá theo bệnh nhân sử dụng dịch vụ khám, chữa bệnh, giá theo mùa...",
            "Kết nối nguồn bệnh nhân, trong chuỗi Hợp Tác với các quỹ hưu trí, bảo hiểm nhân thọ, bảo hiểm sức khỏe.",
            "Chăm sóc điều dưỡng cho cán bộ (hợp tác với Bệnh viện TWQĐ 175).",
          ],
        },
        {
          id: "pharmacy",
          name: "Doanh thu Thuốc & DVTM",
          shared: [
            "Đặc quyền cung cấp các dịch vụ trong khuôn viên bệnh viện.",
          ],
          medical: [],
          nonMedical: [],
        },
        {
          id: "other",
          name: "Thu nhập khác",
          shared: [
            "Tăng thu nhập & quyền thương lượng lãi suất từ quản lý vốn tập trung tại một ngân hàng đầu mối.",
            "Thu nhập từ các khoản đầu tư cùng ngành.",
          ],
          medical: [],
          nonMedical: [],
        },
      ],
    },
    capitalStrategy: {
      title: "Chiến Lược Huy Động Vốn & Quản Trị Tài Chính Holding",
      subtitle:
        "Quản lý vốn tập trung (Sweeping Account) & cơ cấu vốn mục tiêu đạt 1.500 Tỷ VNĐ vốn điều lệ giai đoạn 2026-2028.",
      equity: {
        title: "Vốn Điều Lệ & Phát Hành Cổ Phần",
        desc: "Chào bán riêng lẻ cho các nhà đầu tư chiến lược cùng chia sẻ tầm nhìn; lập kế hoạch niêm yết IPO thị trường chứng khoán.",
      },
      debt: {
        title: "Vốn Vay Ngân Hàng & Quỹ Quốc Tế",
        desc: "Đàm phán hạn mức tín dụng ưu đãi (thời hạn 10 năm, ân hạn 3 năm) với các ngân hàng lớn (BIDV, Vietinbank, VCB) & đối tác Quỹ VIG.",
      },
      cashManagement: {
        title: "Quản Lý Dòng Tiền Tập Trung (Cash Management)",
        desc: "Holding quản lý tập trung dòng tiền mặt tại ngân hàng đầu mối (sweeping account), phê duyệt ngân sách định lượng và trích lập quỹ tái đầu tư.",
      },
      timeline: {
        title: "Tiến Độ Tăng Vốn & Cơ Cấu Sở Hữu (2026-2028)",
        desc: "Mục tiêu đạt 1.500 Tỷ VNĐ vốn điều lệ vào năm 2028 với sự tham gia của nhà đầu tư chiến lược.",
        periods: [
          {
            year: "2026 Q1",
            total: "486 Tỷ",
            hsvRatio: "100%",
            investorRatio: "0%",
          },
          {
            year: "2026 Q4",
            total: "609 Tỷ",
            hsvRatio: "80%",
            investorRatio: "20%",
          },
          {
            year: "2027",
            total: "1,210 Tỷ",
            hsvRatio: "65%",
            investorRatio: "35%",
          },
          {
            year: "2028",
            total: "1,500 Tỷ",
            hsvRatio: "51%",
            investorRatio: "49%",
          },
        ],
      },
    },
  },
  orgChartThuongMai: {
    bod: "HỘI ĐỒNG QUẢN TRỊ",
    ceo: "TỔNG GIÁM ĐỐC",
    deputyCeo: "P.TỔNG GIÁM ĐỐC",
    secretary: "THƯ KÝ",
    salesMarketing: "KHỐI KD & MARKETING",
    customerDev: "PHÁT TRIỂN KHÁCH HÀNG",
    projectBiz: "KINH DOANH DỰ ÁN",
    distribution: "PHÂN PHỐI – BÁN LẺ",
    customerService: "CSKH",
    marketingComm: "MARKETING & TRUYỀN THÔNG",
    technical: "KHỐI KỸ THUẬT",
    projectSupport: "HỖ TRỢ DỰ ÁN",
    techDeployment: "TRIỂN KHAI KỸ THUẬT",
    techCustomerSupport: "HỖ TRỢ KHÁCH HÀNG",
    rnd: "NGHIÊN CỨU – PHÁT TRIỂN",
    support: "KHỐI HỖ TRỢ",
    finance: "TÀI CHÍNH - KẾ TOÁN",
    adminHr: "HÀNH CHÍNH – NHÂN SỰ",
    legal: "PHÁP CHẾ",
    purchasing: "MUA HÀNG",
    labelLeft: "CẤP TRÊN GIAO VIỆC VÀ GIÁM SÁT TIẾN ĐỘ",
    labelRight: "NHÂN VIÊN ĐỀ XUẤT BÁO CÁO LÊN CẤP TRÊN",
    labelBottom: "CÁC KHỐI PHÒNG BAN PHỐI HỢP CHIỀU NGANG",
    table: {
      businessDiv: "KHỐI KINH DOANH",
      techDiv: "KHỐI KỸ THUẬT",
      supportDiv: "KHỐI HỖ TRỢ",
      managementBoard: "BAN TỔNG GIÁM ĐỐC",
      managementBoardDesc: "Quản lý, và điều hành, định hướng hoạt động theo kế hoạch chung công ty.",
      customerDev: "PHÁT TRIỂN KHÁCH HÀNG",
      customerDevDesc: "Tiếp thị qua điện thoại, phát triển khách hàng, nhận diện khách hàng tiềm năng.",
      retail: "BÁN LẺ",
      retailDesc: "Thực hiện những đơn hàng nhỏ, các dự án quy mô Cty 50 người dùng.",
      project: "DỰ ÁN",
      projectDesc: "Phát triển và nhân rộng mối quan hệ khách hàng, tìm hiểu và đáp ứng nhu cầu khách hàng, thực hiện doanh số.",
      management: "QUẢN LÝ",
      managementDesc: "",
      projectSupport: "HỖ TRỢ DỰ ÁN",
      projectSupportDesc: "Phối hợp phòng kinh doanh để tìm hiểu, tư vấn về đề xuất các giải pháp hỗ trợ khách hàng.",
      techSolutions: "GIẢI PHÁP CÔNG NGHỆ",
      techSolutionsDesc: "Nghiên cứu và ứng dụng mới, phát triển, triển khai, công nghệ phần mềm, HIS, LIS, iCLINIC, ERP, AI, IOT, CN 4.0.",
      systemSolutions: "HỆ THỐNG GIẢI PHÁP",
      systemSolutionsDesc: "Xây dựng giải pháp kỹ thuật, quản trị mạng, triển khai giải pháp kỹ thuật, triển khai bảo mật hệ thống, tập trung nghiên cứu sâu về bảo mật hệ thống, Pentest, Auditing, kết hợp với iSEC.",
      services: "DỊCH VỤ",
      servicesDesc: "Hỗ trợ khách hàng theo chính sách bán hàng, bảo trì, bảo hành.",
      rndTraining: "R&D, ĐÀO TẠO",
      rndTrainingDesc: "Phát triển, công nghệ và đào tạo hướng dẫn nội bộ công ty và khách hàng.",
      supervision: "GIÁM SÁT",
      supervisionDesc: "",
      financeHr: "TC-KT-NS",
      financeHrDesc: "Tài chính - Kế toán - Nhân sự",
      administration: "HÀNH CHÍNH",
      administrationDesc: "Hành chính, Trợ lý"
    }
  },
  esm_pres: {
    page_title: "Ecosystem Smart Medic",
    breadcrumb_parent: "Hệ sinh thái",
    breadcrumb_current: "Ecosystem Smart Medic",
    page_subtitle: "Giải pháp công nghệ toàn diện cho ngành Y tế, kết nối bệnh nhân, bệnh viện và nhà thuốc.",
    hero_kicker: "GIẢI PHÁP CÔNG NGHỆ CHO NGÀNH Y TẾ",
    hero_title: "Ecosystem Smart Medic",
    hero_desc: "Xây dựng và phát triển nền tảng ứng dụng y tế thông minh, kết nối truyền thống giữa Bệnh nhân và Bệnh viện – Phòng khám – Nhà thuốc thông qua công nghệ Platform đột phá.",
    platform_intro: {
      title: "ỨNG DỤNG CÔNG NGHỆ PLATFORM",
      desc: "Từ các bước phân tích ban đầu và với việc ứng dụng Công nghệ thông tin vào lĩnh vực Y tế. HSV ứng dụng mô hình giải pháp “Hệ sinh thái Y tế thông minh – Ecosystem Smart Medic” như sau:"
    },
    gears_relation: {
      title: "Liên quan tương ứng giữa “Bệnh nhân” – “Bệnh viện – Phòng khám – Nhà thuốc” – “Nhà cung cấp”",
      heading: "Trong Mô hình Hệ sinh thái, Bệnh viện – Phòng khám – Phòng mạch – Nhà thuốc được hiểu như sau:",
      supplier: "Nhà cung cấp",
      hospital: "Bệnh viện / Phòng khám",
      patient: "Bệnh nhân",
      items: [
        { label: "Bệnh viện thuộc hệ thống:", value: "Medika, Pacific, Healthcare, Phương Châu, Hoàn Mỹ, Tâm Trí ..." },
        { label: "Phòng Khám thuộc hệ thống:", value: "Medika, Pacific, Healthcare, Phương Châu, Hoàn Mỹ, Tâm Trí ...." },
        { label: "Nhà thuốc thuộc hệ thống:", value: "Trong hệ sinh thái ESM (Pharmacity ......)" },
        { label: "Bệnh viện liên kết:", value: "Medika, Pacific, Healthcare, Phương Châu, Hoàn Mỹ, Tâm Trí ....." },
        { label: "Phòng khám liên kết:", value: "Medika, Pacific, Healthcare, Phương Châu, Hoàn Mỹ, Tâm Trí ......" }
      ]
    },
    benefits_title: "10 LỢI ÍCH KHI THAM GIA HỆ SINH THÁI Y TẾ THÔNG MINH ESM",
    benefits: {
      benefit1: "Tiếp Cận Người Dùng và Thông Tin Y Tế Dược",
      benefit2: "Thích ứng với việc thay đổi cách chăm sóc sức khỏe",
      benefit3: "Đa Thương Mại",
      benefit4: "Quản Lý Từ Bảng Điều Khiển Trung Tâm",
      benefit5: "Kết Nối Đa Kênh",
      benefit6: "Chăm sóc sức khỏe chuyên môn Online",
      benefit7: "Không Giới Hạn Địa Lý",
      benefit8: "Kinh tế, lợi nhuận và tức thời",
      benefit9: "Tệp Khách Hàng Y Tế Dược",
      benefit10: "Trải nghiệm dịch vụ Y Tế Dược chuyên nghiệp theo mô hình số hóa trong đại AI"
    },
    roles_and_features: {
      role_title: "Vai trò của Bệnh nhân / Khách hàng",
      role_patient: "Là \"Bệnh nhân\" khi điều trị hoặc Khám chữa bệnh",
      role_customer: "Là \"Khách hàng\" khi mua hàng của nhà cung cấp đã và đang liên kết với các Bệnh viện – Phòng khám – Nhà thuốc",
      ecosystem_corr_title: "Tương quan trong Hệ sinh thái",
      ecosystem_corr_1: "Đến điều trị tại Bệnh viện – Phòng khám – Nhà thuốc thuộc Tập đoàn hoặc Đối tác",
      ecosystem_corr_2: "Đến điều trị tại Bệnh viện – Phòng khám – Nhà thuốc nằm trong hợp tác",
      ecosystem_corr_3: "Những khách hàng từng có bệnh",
      ecosystem_corr_4: "Khách hàng cần chăm sóc sức khỏe cho bản thân, gia đình, người thân, đồng nghiệp",
      feature_title: "Tương quan giữa Khách hàng – Bệnh viện – Phòng khám – Bác sĩ",
      f_hospital: {
        title: "BỆNH VIỆN",
        items: [
          "Tiếp cận thông tin bệnh nhân, sàng lọc và phân luồng",
          "Mở rộng tệp khách hàng",
          "Cung cấp các gói khám, dịch vụ mở rộng, thăm khám định kỳ",
          "Lên lịch và điều phối nhân sự chủ động",
          "Quản lý khám, thống kê báo cáo trên biểu đồ Platform ESM",
          "Xem vị trí Bệnh viện trong bán kính gần nhất"
        ]
      },
      f_clinic: {
        title: "PHÒNG KHÁM",
        items: [
          "Tiếp cận thông tin bệnh nhân, sàng lọc và phân luồng",
          "Mở rộng tệp khách hàng theo chuyên ngành phòng khám",
          "Cung cấp gói khám, giá gói khám trên hệ sinh thái ESM",
          "Lên lịch tiếp nhận và tư vấn khách hàng",
          "Xem vị trí Phòng khám trong bán kính gần nhất"
        ]
      },
      f_doctor: {
        title: "BÁC SĨ",
        items: [
          "Tiếp cận sớm thông tin bệnh nhân",
          "Tham chiếu thông tin một cách toàn diện vào hệ thống",
          "Tiếp cận hệ thống khám chữa bệnh y tế thông minh",
          "Tư vấn và chẩn đoán bệnh"
        ]
      },
      f_patient: {
        title: "BỆNH NHÂN",
        items: [
          "Lựa chọn Bệnh viện và Bác sĩ theo tuyến, vị trí, chuyên khoa",
          "Gói khám, hẹn và nhắc lịch khám, uống thuốc, tái khám",
          "Tư vấn sàng lọc trước và sau viện",
          "Phát thuốc tận nơi",
          "Xem vị trí Nhà thuốc trong bán kính gần nhất",
          "Tải hồ sơ bệnh án, KQ xét nghiệm",
          "Theo dõi bệnh từ xa",
          "Thanh toán điện tử..."
        ]
      },
      tech_shift_title: "Bệnh nhân - Khách hàng tiếp cận công nghệ",
      badge_problem: "VẤN ĐỀ",
      badge_solution: "GIẢI PHÁP",
      role_source: "Bệnh nhân",
      tech_overload: {
        title: "QUÁ TẢI TRONG TUYẾN KHÁM CHỮA BỆNH",
        desc: "Sự quá tải trong Bệnh viện, Phòng khám, Nhà thuốc và nhu cầu chăm sóc sức khỏe ngày càng gia tăng, cần sự thăm khám chỉ định chuyên môn. Vì thế, xu hướng phát triển Mạng lưới công nghệ Y tế là cần thiết."
      },
      tech_solution: {
        title: "GIẢI PHÁP CÔNG NGHỆ Y TẾ ESM",
        desc: "Phát triển mạng lưới công nghệ Y tế thăm khám từ xa, chẩn đoán, phân loại. Nhờ công nghệ AI và Big Data điều phối công việc truy xuất và theo dõi bệnh nhân tức thời, xuyên suốt, tăng độ chính xác và giảm thiểu rủi ro quá tải."
      }
    },
    traditional: {
      title: "Kết nối truyền thống",
      subtitle: "Cách tiếp cận giữa Bệnh nhân và Bệnh viện – Phòng khám – Nhà thuốc hiện tại",
      methods: {
        bhyt: "Thông qua kênh Khám chữa bệnh từ thẻ BHYT",
        insurance: "Liên kết với các đơn vị tư vấn Bảo hiểm",
        communication: "Thông qua kênh truyền thông tại khu vực",
        social: "Truyền thông, Quảng cáo, Mạng xã hội, Google Ads, KOLs/KOCs",
        referral: "Thông qua kênh giới thiệu từ Doanh nghiệp, Bạn bè, Người thân",
        radius: "Các Bệnh viện, Phòng khám, Nhà thuốc trong khu vực bán kính 5km",
        gprs: "Tự tìm đến vị trí gần nhất bằng công nghệ GPRS"
      },
      limitations_title: "Điểm hạn chế của liên kết truyền thống",
      limitations: {
        l1: "Khó khăn tiếp cận dịch vụ chăm sóc sức khỏe mọi lúc mọi nơi",
        l2: "Thiếu thông tin tư vấn Bệnh, Dược phẩm, Bảo hiểm",
        l3: "Khó tìm đúng Bác sĩ chuyên khoa tại các Bệnh viện, Phòng khám",
        l4: "Hạn chế dịch vụ thanh toán thẻ (quét QR) bằng công nghệ",
        l5: "Khó khăn khi tiếp cận Hồ sơ thông tin bệnh án điện tử",
        l6: "Đứt gãy kết nối với Nhà cung cấp sản phẩm, bảo hiểm"
      }
    },
    blockchain_title: "Nền Tảng Blockchain Lưu Trữ",
    blockchain_desc: "Ứng dụng công nghệ Blockchain trong lưu trữ hồ sơ bệnh án, hợp đồng và quản lý thanh toán.",
    bc_security: "Bảo Mật Tối Đa",
    bc_security_desc: "Dữ liệu phân cấp, hợp đồng thông minh đảm bảo tính toàn vẹn và an toàn tuyệt đối cho hồ sơ bệnh án.",
    bc_data: "Lưu Trữ Bệnh Án",
    bc_data_desc: "Hồ sơ y tế được lưu giữ minh bạch, dễ dàng truy xuất cho quá trình theo dõi và điều trị.",
    bc_smart: "Thanh Toán Số",
    bc_smart_desc: "Giao dịch khám chữa bệnh, mua thuốc được thực hiện nhanh chóng thông qua ví điện tử và token."
  },
  
  // ===== ESM CORRELATION DIAGRAM =====
  esm_correlation_diagram: {
    title: "TƯƠNG QUAN GIỮA ESM- KHỐI Y TẾ - KHỐI DƯỢC - NHÀ PHÂN PHỐI",
    web_user: "Web User",
    app_user: "App User",
    master_platform: "MASTER PLATFORM",
    sub_platform_1: "Sub Platform 1",
    sub_platform_2: "Sub Platform 2",
    sub_platform_3: "Sub Platform 3",
    sub_platform_n: "Sub Platform n",
    token: "Token",
    consensus: "Consensus",
    pow_pos: "PoW / PoS",
    smart_contact: "SmartContact",
    call: "Call",
    tim_kiem: "Tìm kiếm",
    so_sanh: "So sánh dịch vụ",
    trai_nghiem: "Trải nghiệm",
    dang_ky: "Đăng ký KCB",
    thong_tin_yt: "Thông tin Y tế",
    truy_xuat: "Truy xuất nguồn gốc",
    mua_san_pham: "Mua sản phẩm",
    lua_chon_bs: "Lựa chọn Bác Sĩ",
    nganh_dv_khac: "Ngành dịch vụ khác",
    lich_su_gd: "Lịch sử giao dịch",
    kenh_tap_doan: "Kênh Tập đoàn",
    dv_ho_tro: "Dịch vụ hỗ trợ",
    giao_dich_ncc: "Giao dịch nhà cung sản phẩm",
    tai_ho_so: "Tải hồ sơ bệnh án, KQ-Xét nghiệm",
    ho_so_tt: "Hồ sơ TT Bệnh án",
    infra_arch: "Hạ tầng kiến trúc Hệ Sinh Thái (DB, Schema, Multi-Tenant, Search Engine,...)",
    infra_cloud: "Hạ tầng Cloud và CDN của Hệ Sinh Thái ESM, HSV",
    blockchain: "Blockchain",
    tech_partner: "Đối tác Công nghệ"
  },

  // ===== DATA SYSTEM MODEL DIAGRAM =====
  data_system_model: {
    title: "Mô hình hệ thống dữ liệu: Đối tác chính",
    main_partner: "Đối tác chính",
    hospital: "Bệnh viện",
    pharmacy: "Nhà thuốc",
    real_estate: "Bất động sản",
    supplier: "Nhà cung cấp",
    clinic: "Phòng khám",
    bank: "Ngân hàng",
    supermarket: "Siêu thị",
    delivery: "Giao hàng",
    doctor: "Bác sĩ",
    insurance: "Bảo hiểm",
    education: "Ngành Giáo Dục",
    other_services: "Dịch vụ khác"
  },

  // ===== BUSINESS MODEL TABS =====
  business_model_tabs: {
    title: "MÔ HÌNH KINH DOANH",
    tab_overview: "Tổng quan",
    tab_canvas: "Cấu trúc",
    tab_activities: "Hoạt động",
    tab_resources: "Tài nguyên",
    tab_value: "Giá trị",
    qr_scan_title: "QUÉT MÃ QR CODE - PLATFORM NẰM TRONG HỆ SINH THÁI Y TẾ <strong><span style=\"color: #16a34a\">ESM</span></strong> - TẠI CÁC BV, PK, NHÀ THUỐC, DOANH NGHIỆP & CHIA SẺ TỪ BẠN BÈ, NGƯỜI THÂN",
    qr_banner_slogan: "Sức khỏe của bạn, chăm sóc của chúng tôi",
    qr_banner_title: "Cung cấp <span class=\"text-blue\">dịch vụ chăm sóc sức khỏe</span> toàn diện",
    qr_banner_subtext: "ESM cung cấp các sản phẩm Dược phẩm, dịch vụ y tế và chăm sóc sức khỏe",

    overview: {
      tech_group: "TẬP ĐOÀN CUNG CẤP CÔNG NGHỆ",
      tech_group_desc: "Là nhà cung cấp hạ tầng, Cloud công nghệ và giải pháp, Ngân hàng, Giáo dục, Bệnh viện, BĐS, Nông nghiệp, Lâm nghiệp",
      hsv: "HSV",
      hsv_desc: "Là nhà cung cấp công nghệ và giải pháp hạ tầng phần cứng, phần mềm Smart cho Hệ sinh thái Y tế ESM, Platform",
      others: "Các Thành Viên khác",
      others_1: "Giúp hỗ trợ hành lang pháp lý.",
      others_2: "Tổ chức, Truyền thông, quảng bá sản phẩm.",
      others_3: "Cung cấp thông tin sản phẩm.",
      others_4: "Thực hiện các giao dịch vụ khác."
    },
    
    canvas: {
      partners: "Đối tác chính",
      activities: "Hoạt động chính",
      resources: "Tài nguyên chính",
      value: "Mệnh đề giá trị",
      relations: "Quan hệ khách hàng",
      channels: "Kênh",
      segments: "Phân khúc khách hàng",
      costs: "Cấu trúc chi phí",
      revenue: "Nguồn doanh thu"
    },

    activities: {
      title: "Hoạt động chính",
      dev_platform: "Phát triển Platform cho Hệ Sinh Thái ESM",
      build_esm: "Xây dựng Hệ Sinh Thái ESM bao gồm",
      build_1: "Đăng ký Khám chữa bệnh",
      build_2: "Thông tin về ngành Y tế",
      build_3: "Đăng ký Bác sĩ",
      build_4: "Tra cứu và xem KQ - CLS, TT hồ sơ bệnh án điện tử",
      build_5: "Mua sản phẩm, truyền thông, khác",
      build_6: "Truy xuất nguồn gốc sản phẩm",
      operate: "Vận hành ESM"
    },

    resources: {
      title: "Tài nguyên chính",
      finance: "Nguồn lực tài chính",
      finance_1: "HSV",
      finance_2: "Tập Đoàn",
      finance_3: "Đối tác khác",
      tech: "Phát triển công nghệ Platform",
      tech_1: "Tập Đoàn",
      tech_2: "HSV",
      tech_3: "Đối tác khác"
    },

    value: {
      title: "Mệnh đề giá trị",
      v1: "Mô hình PaaS duy nhất ở VN",
      v2: "Cho phép các Bệnh viện, Phòng khám, Phòng mạch, Nhà thuốc và Bác sĩ tự làm kinh doanh với mô hình Liên kết chuỗi",
      v3: "Sàn sản phẩm trên Hệ Sinh Thái Y Tế ESM có thể hiển thị toàn bộ nội dung sản phẩm của các đối tượng mặt hàng",
      v4: "Bệnh nhân / Khách hàng có thể gọi điện thoại IP ngay từ Web / App với tổ tư vấn",
      v5: "Hệ sinh thái Y tế ESM quy tụ đầy đủ các Bác sĩ đầu ngành, cung cấp các sản phẩm và dịch vụ tốt nhất với khả năng truy xuất triệt để nguồn gốc sản phẩm thông qua công nghệ chip NFC",
      v6: "Đầy đủ các tính năng: Đặt lịch khám, gọi bác sĩ, tư vấn, mua sản phẩm, mua bảo hiểm tự nhân, Tuyển dụng BS, ĐD, NHS, Tổ chức hội thảo ngành y khoa, truy xuất nguồn gốc và tìm kiếm sản phẩm",
      v7: "Nền tảng Blockchain"
    },
    relations: {
      title: 'Quan hệ khách hàng',
      c1: '<strong><span style="color: #16a34a">HSV</span></strong> liên hệ trực tiếp với các Tập đoàn, <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phương Châu, Hoàn Mỹ, Tâm Trí Ái Nghĩa, 315</span></strong> ... và các thành viên trong thuộc Hệ Sinh Thái Y tế',
      c2: '<strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phương Châu, Hoàn Mỹ, Tâm Trí, Ái Nghĩa, 315</span></strong> quan hệ với Các Bệnh viện, Phòng khám, Phòng mạch, Nhà thuốc, Bác sĩ đầu ngành và các đối tác liên quan đến Y tế.',
      c3_title: 'Tập đoàn, <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phương Châu, Hoàn Mỹ, Tâm Trí, Ái Nghĩa, 315</span></strong> quan hệ với các đối tác thuộc các lĩnh vực ngành nghề khác :',
      c3_list: [
        'Dược phẩm / Thực phẩm chức năng......',
        'Ngân hàng.',
        'Bảo hiểm.',
        'Vận chuyển nhanh.',
        'Bất động sản, Nông Nghiệp, Lâm Nghiệp, Giáo Dục',
        'v.v.....'
      ]
    },
    channels: {
      title: 'Kênh',
      c1_title: 'Kinh doanh Hệ sinh thái Y tế <strong><span style="color: #16a34a">ESM</span></strong> qua kênh online:',
      c1_list: [
        'Khách hàng là bệnh nhân.',
        'Khách hàng cá nhân kết nối vào hệ sinh thái.',
        'Khách hàng mua bảo hiểm tư nhân.',
        'Khách hàng khối doanh nghiệp, Bạn bè, Người thân, Gia đình',
        'Khách hàng tham gia BHYT, BHXH, YTCC'
      ],
      c2_list: [
        'Truyền thông Quảng cáo trực tiếp.',
        'Đội ngũ chăm sóc khách hàng tại Chuỗi Bệnh viện - Phòng khám - Phòng mạch - Nhà thuốc',
        'Kênh Truyền thông Quảng cáo truyền hình - đài phát thanh.....',
        'Kênh tuyển dụng BS, ĐD, NHS',
        'Kênh hội nghị truyền hình trực tiếp các hội thảo chuyên đề về lĩnh vực ngành y tế'
      ]
    },
    segments: {
      title: 'Phân khúc khách hàng',
      c1: 'Khách hàng của Hệ sinh thái Y tế là những khách hàng cá nhân, chủ doanh nghiệp, tổ chức, v.v.. khi tham gia vào Hệ Sinh Thái Y tế <strong><span style="color: #16a34a">ESM</span></strong> đều được cấp một ID Member.',
      c2: 'Các Chuỗi Bệnh viện, Chuỗi Phòng khám, Chuỗi Nhà thuốc, Bác sĩ, tham gia trong lĩnh vực thuộc ngành Y tế. Sẽ nằm trong hệ thống <strong><span style="color: #16a34a">ESM</span></strong> trên bản đồ Google Maps Việt Nam',
      c3: 'Các đơn vị, tổ chức khác vv....'
    },
    revenue: {
      title: 'Nguồn doanh thu',
      c1: 'Nguồn thu từ khách hàng, bệnh nhân, đối tác của <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phương Châu, Hoàn Mỹ, Tâm Trí, PK Ái Nghĩa, PK 315</span></strong>.....',
      c2: 'Nguồn thu từ Đối tác sử dụng Hệ Sinh Thái Y tế (sàn giao dịch, App,v.v...',
      c3_title: 'Nguồn thu từ quảng cáo:',
      c3_list: [
        'Tại Bệnh viện - Phòng khám - Phòng mạch - Nhà thuốc, trực thuộc <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phương Châu, Hoàn Mỹ, Tâm Trí, PK Ái Nghĩa, 315</span></strong>....',
        'Tại Bệnh viện - Phòng khám - Phòng mạch - Nhà thuốc liên kết <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phương Châu, Hoàn Mỹ, Tâm Trí, PK Ái Nghĩa, PK 315</span></strong>.....',
        'Trên Website, Hệ Sinh Thái Y tế, <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phương Châu, Hoàn Mỹ, Tâm Trí, PK Ái Nghĩa, PK 315</span></strong>....',
        'Trên App Hệ Sinh Thái <strong><span style="color: #16a34a">Medika, Pacific, Heathcare</span></strong> Các khoản thu khác trực thuộc Hệ Sinh Thái <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phương Châu, Hoàn Mỹ, Tâm Trí, PM Ái Nghĩa, PK 315</span></strong>....'
      ]
    }
  }
};
export default vi;
